module.exports = {
      id: "PayPal-usage",
      viewBox: "0 0 34 24",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#PayPal-usage",
      toString: function () {
        return this.url;
      }
    }